import axios from "axios";

const http = axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
});

http.interceptors.request.use(
  (config) => {
    const key = localStorage.getItem("accessToken");
    if (key) {
      config.headers = {
        Authorization: key,
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) return;
  const res = await axios.post(
    `${process.env.REACT_APP_FIREBASE_SECURE_TOKEN}v1/token?key=${process.env.REACT_APP_API_KEY}`,
    { grant_type: "refresh_token", refresh_token: refreshToken }
  );
  return res.data;
};

http.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    if (
      error.response &&
      ((error.response && error.response.status === 403) ||
        (error.response && error.response.status === 401)) &&
      originalRequest.url !== "/v1/token" &&
      !originalRequest._retry
    ) {
      localStorage.removeItem("accessToken");
      originalRequest._retry = true;
      try {
        const token = await refreshAccessToken();
        if (token) {
          axios.defaults.headers.common["Authorization"] = token.access_token;
          localStorage.setItem("accessToken", token.access_token);
          return http(originalRequest);
        }
      } catch (err) {
        localStorage.removeItem("refreshToken");
      }
    }
    return Promise.reject(error);
  }
);

const get = (url, headers = {}, params = {}) => {
  return http.get(url, {
    ...params,
    headers: {
      ...headers,
    },
  });
};

const post = (url, data, headers = {}, params = {}) => {
  return http.post(url, data, {
    params: {
      ...params,
    },
    headers: {
      ...headers,
    },
  });
};

const put = (url, data, headers = {}) => {
  return http.put(url, data, {
    headers: {
      ...headers,
    },
  });
};

const remove = (url, params = {}, headers = {}) => {
  return http.delete(url, {
    headers: {
      ...headers,
    },
    data: {
      ...params,
    },
  });
};

const patch = (url, data, headers = {}) => {
  return http.patch(url, data, {
    headers: {
      ...headers,
    },
  });
};

const Request = {
  get,
  post,
  put,
  remove,
  patch,
};

export default Request;
